// The typed failures of the catalogue, and the format constants a manifest is judged by. Kept apart
// from engine.ts and download.ts so the main thread can name them without bundling the worker's code.

/** PRAGMA application_id of a proef catalogue: 'PROF'. */
export const APPLICATION_ID = 0x50524f46;
/** The newest schema this reader understands; a file whose min_reader_schema is higher is refused. */
export const READER_SCHEMA = 1;

export type FormatProblem = "not-a-catalogue" | "too-new" | "fold-mismatch" | "version-mismatch";

/** The file is not a catalogue this build can read; `problem` says why. */
export class CatalogueFormatError extends Error {
  readonly problem: FormatProblem;
  constructor(problem: FormatProblem, message: string) {
    super(message);
    this.name = "CatalogueFormatError";
    this.problem = problem;
  }
}

/** The delta layout this build can apply; a manifest advertising another is ignored. */
export const DELTA_FORMAT = 1;

/** Why applying a catalogue delta stopped; any of them sends the device back to the full bundle. */
export type DeltaFailure = "format" | "base" | "apply" | "incomplete" | "digest";

export class DeltaError extends Error {
  readonly failure: DeltaFailure;
  constructor(failure: DeltaFailure, message: string) {
    super(message);
    this.name = "DeltaError";
    this.failure = failure;
  }
}

export type DownloadFailure = "http" | "size" | "digest" | "decode" | "aborted";

export class DownloadError extends Error {
  readonly failure: DownloadFailure;
  constructor(failure: DownloadFailure, message: string) {
    super(message);
    this.name = "DownloadError";
    this.failure = failure;
  }
}
